import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Input, ListScreen, Message, Product, Select} from '../components';
import {
    fetchFullProducts,
    cleanFullProducts,
    setUser,
    changeUserSetting,
    deleteFullProduct,
    deleteFullProducts,
} from '../actions';
import {__, formatAmount, formatDate, request, toNumber} from '../functions';
import '../assets/styles/full-products.css';
import ViewIcon from '@mui/icons-material/Folder';
import SmartToyIcon from "@mui/icons-material/SmartToy";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {AI_FUNCTION_NAMES, AI_TRANSLATE_FUNCTION_SLUG, AI_TRANSLATE_PRODUCT_INPUTS} from "../config";
import {Chip} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Publish";

class FullProductsScreen extends ListScreen {
    title = __('Produkty');

    state = { ...ListScreen.state, ...{
        lightbox: {
            delete: false,
            multidelete: false,
            multiai: false,
            importExcel: false,
        },
    }};

    aiVariableInputs = {
        product_name: __('Názov produktu'),
        product_parameters: __('Parametre produktu'),
        product_short_description: __('Krátky popis produktu'),
        product_description: __('Dlhý popis produktu'),
    };

    defaultAiVariableInputs = { product_name: 'product_name' };

    memoryCache = {};

    afterFetchList() {
        const { params } = this.props;

        if (_.has(params, 'ai_command_id') && toNumber(params.ai_command_id) > 0) {
            this.showLightbox('multiai', {
                slug: '',
                variable_inputs: this.defaultAiVariableInputs,
                variables: {},
                ids: `ai_command_id:${params.ai_command_id}`,
                callback: () => {},
                callbackLoading: () => {},
            });
        }
    }

    isValidPermission() {
        return this.hasPermission('products');
    }

    getTableName() {
        return 'full-products';
    }

    getListClassName() {
        return 'list-full-products';
    }

    getTags() {
        const { user, items } = this.props;

        const user_eshop_id = toNumber(user.user_eshop_id);

        return [
            items.active_import ? {
                name: __('Prebieha import produktov z eshopu.'),
                color: 'orange',
            } : (user_eshop_id > 0 ? {
                name: __('Znovu načítať všetky produkty z eshopu'),
                onClick: () => this.restart(),
                icon: <RefreshIcon />,
            } : null),
            items.has_parameters ? (items.active_import_parameters ? {
                name: __('Prebieha import parameterov z eshopu.'),
                color: 'orange',
            } : (user_eshop_id > 0 ? {
                name: __('Znovu načítať všetky parametre z eshopu'),
                onClick: () => this.restartParameters(),
                icon: <RefreshIcon />,
            } : null)) : null,
            {
                name: __('Kategórie'),
                onClick: () => this.redirect('/products/categories'),
                icon: <ArrowForwardIcon />,
                className: 'categories-tag',
            },
            _.includes([552], user_eshop_id) && !items.active_import ? {
                name: __('Import Excel zo súboru'),
                onClick: () => this.showLightbox('importExcel', { loading: false }),
                color: 'secondary',
            } : null,
        ];
    }

    getMultiselect() {
        const { items } = this.props;

        return [
            {
                confirm: (ids, callback, callbackLoading) => this.showLightbox('multiai', {
                    slug: '',
                    variable_inputs: this.defaultAiVariableInputs,
                    variables: {},
                    ids,
                    callback,
                    callbackLoading,
                }),
                icon: <SmartToyIcon color="orange" />,
                text: __('AI úloha'),
                limit: items.max_multi_ai_items,
                permission: 'aicommands',
            },
            {
                confirm: (ids, callback, callbackLoading) => this.showLightbox('multidelete', {
                    ids,
                    callback,
                    callbackLoading,
                }),
                icon: <DeleteIcon />,
                text: __('Zmazať'),
                permission: 'products-delete',
            }
        ];
    }

    getMultiselectId(id) {
        return _.toString(id);
    }

    getFilter() {
        const { items } = this.props;

        return _.reduce(items.filter, (result, options, key) => {
            switch (key) {
                case 'category_id':
                    return { ...result, ...{ [key]: {
                        type: 'select',
                        name: __('Kategória'),
                        value: '',
                        options,
                    }}};

                case 'manufacturer':
                    return { ...result, ...{ [key]: {
                        type: 'select',
                        name: __('Výrobca'),
                        value: '',
                        options,
                    }}};

                case 'ean':
                    return { ...result, ...{ [key]: {
                        type: 'input',
                        name: __('EAN'),
                        value: '',
                    }}};

                case 'search':
                    return { ...result, ...{ [key]: {
                        type: 'input',
                        name: __('Hľadať'),
                        value: '',
                    }}};

                default:
                    return result;
            }
        }, {})
    }

    getColumns() {
        if (this.isMobile()) {
            return super.getColumns();
        }

        return [ '', ...super.getColumns() ];
    }

    getCells(item) {
        // Vytiahneme nastavenia buniek
        const cellsSettings = this.getCellsSettings();

        // Vytiahneme options buniek
        const cellsOptions = this.getCellsOptions();

        if (!_.has(this.memoryCache, 'hasPermissionAi')) {
            this.memoryCache.hasPermissionAi = this.hasPermission('aicommands');
        }

        if (!_.has(this.memoryCache, 'hasPermissionView')) {
            this.memoryCache.hasPermissionView = this.hasPermission('products-view');
        }

        if (!_.has(this.memoryCache, 'hasPermissionDelete')) {
            this.memoryCache.hasPermissionDelete = this.hasPermission('products-delete');
        }

        let cells = [
            <div>
                {this.getCellValue(cellsOptions[cellsSettings.settings[0][0]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[0][1]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[0][2]].get(item))}
            </div>,
            <div>
                {this.getCellValue(cellsOptions[cellsSettings.settings[1][0]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[1][1]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[1][2]].get(item))}
            </div>,
            <div>
                {this.getCellValue(cellsOptions[cellsSettings.settings[2][0]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[2][1]].get(item))}
                {this.getCellValue(cellsOptions[cellsSettings.settings[2][2]].get(item))}
            </div>,
            <div>
                {this.memoryCache.hasPermissionAi ? this.renderTableButton(
                    item.id,
                    __('AI úloha'),
                    <SmartToyIcon color="orange" />,
                    (callbackLoading, callback) => this.showLightbox('multiai', {
                        slug: '',
                        variable_inputs: this.defaultAiVariableInputs,
                        ids: item.id,
                        callback,
                        callbackLoading,
                    }),
                    {}
                ) : null}
                {this.memoryCache.hasPermissionView ? this.renderTableButton(
                    item.id,
                    __('Zobraziť'),
                    <ViewIcon />,
                    (callbackLoading, callback) => this.showDrawer('product', { id: item.id }),
                    {}
                ) : null}
                {this.memoryCache.hasPermissionDelete ? this.renderTableButton(
                    item.id,
                    __('Zmazať'),
                    <DeleteIcon />,
                    (callbackLoading, callback) => this.confirmDelete(item.id, callbackLoading, callback),
                    {}
                ) : null}
            </div>,
        ];

        if (!this.isMobile()) {
            cells = [ <div>
                <div className="full-product__product-image">
                    {_.has(item, 'img_url') && !_.isEmpty(item.img_url) ? <img src={item.img_url} /> : null}
                </div>
            </div>, ...cells ];
        }

        return cells;
    }

    getCellsOptions() {
        return {
            name: {
                label: __('Názov'),
                get: item => _.has(item, 'translations') && _.has(item.translations, 'name')
                    ? _.truncate(item.translations.name, { length: 48 })
                    : '-',
            },
            amount: {
                label: __('Celková cena'),
                get: item => _.has(item, 'pricelists') && _.has(item.pricelists, 'price_vat')
                    ? formatAmount(item.pricelists.price_vat, item.pricelists.currency)
                    : '-',
            },
            number_ean: {
                label: __('Číslo produktu | EAN'),
                get: item => `${_.has(item, 'number') && item.number !== '' ? item.number : '-'} / ${_.has(item, 'ean') && item.ean !== '' ? item.ean : '-'}`,
            },
            stock: {
                label: __('Stav na sklade'),
                get: item => _.has(item, 'stock') ? formatAmount(item.stock, 'ks', 0) : '-',
            },
            weight: {
                label: __('Váha'),
                get: item => _.has(item, 'weight') ? formatAmount(item.weight, 'kg', 2) : '-',
            },
            modified: {
                label: __('Posledná zmena'),
                get: item => formatDate(item.modified, 'dd.mm.yyyy hh:ii'),
            },
            variant: {
                label: __('Varianty'),
                get: item => item.variants.length,
            },
            manufacturer: {
                label: __('Výrobca'),
                get: item => _.has(item, 'manufacturer') && item.manufacturer !== ''
                    ? _.truncate(item.manufacturer, { length: 32 })
                    : '-',
            },
            tax: {
                label: __('DPH'),
                get: item => _.has(item, 'pricelists') && _.has(item.pricelists, 'tax')
                    ? formatAmount(item.pricelists.tax, '%', 0)
                    : '-',
            },
        };
    }

    getEmptyText() {
        return __('Zatiaľ nemáte žiadne produkty');
    }

    confirmDelete(id, callbackLoading, callback) {
        this.showLightbox('delete', { id, callbackLoading, callback });
    }

    onChangeImportExcel(type, value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, importExcel: { ...lightbox.importExcel, [type]: value } } });
    }

    uploadExcelFile(file) {
        this.onChangeImportExcel('loading', true);

        request('/prime/uploadExcel', file, 'FILE').then(response => {
            const { status } = response.data;

            this.onChangeImportExcel('loading', false);

            if (status === 'error') {
                // Nepodarilo sa nahrat prilohu
                this.showSnackbar('error', __('Nepodarilo sa nahrať súbor'));
                return;
            }

            // Nastavime prilohu
            window.location = '/products';
        });
    }

    restart() {
        if (this.isDemo()) {
            this.showSnackbar('error', __('Nie je možné spustiť na DEMO účte'));
            return;
        }

        request('/products-full/restart').then(response => {
            const { status } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa načítať produkty'));
                return;
            }

            // Nastavime prilohu
            window.location = '/products';
        });
    }

    restartParameters() {
        if (this.isDemo()) {
            this.showSnackbar('error', __('Nie je možné spustiť na DEMO účte'));
            return;
        }

        request('/products-full/restart-parameters').then(response => {
            const { status } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa načítať parametre'));
                return;
            }

            // Nastavime prilohu
            window.location = '/products';
        });
    }

    onChangeMultiAi(type, value) {
        const { items } = this.props;
        const { lightbox } = this.state;

        let additional = {};

        if (type === 'slug') {
            let variables = {};

            if (
                _.has(items.ai_functions_variables, value)
                && !_.isEmpty(items.ai_functions_variables[value])
            ) {
                variables = _.reduce(items.ai_functions_variables[value], (result, variable_value, variable_name) => {
                    if (_.isObject(variable_value)) {
                        variable_value = variable_value.default;
                    }

                    return { ...result, [variable_name]: variable_value };
                }, {});
            }

            additional = { variables, variable_inputs: this.defaultAiVariableInputs };
        }

        this.setState({ lightbox: { ...lightbox, multiai: { ...lightbox.multiai, [type]: value, ...additional } } });
    }

    async delete() {
        const { deleteFullProduct, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Produkt nie je možné zmazať na DEMO účte'))
            this.closeLightbox('delete');
            return;
        }


        // Zavolame loading
        lightbox.delete.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('delete');

        // Zmazeme produktu
        await deleteFullProduct(this, lightbox.delete.id);

        // Zavolame callback
        lightbox.delete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    async multiDelete() {
        const { deleteFullProducts, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Produkty nie je možné zmazať na DEMO účte'))
            this.closeLightbox('multidelete');
            return;
        }

        // Zavrieme lightbox
        this.closeLightbox('multidelete');

        // Zobrazime loading
        lightbox.multidelete.callbackLoading();

        // Zmazeme produktov
        await deleteFullProducts(this, lightbox.multidelete.ids, items.filtered);

        // Zavolame callback
        lightbox.multidelete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    async multiAi() {
        const { items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Nie je možné spustiť na DEMO účte'));
            return;
        }

        if (_.isEmpty(lightbox.multiai.slug)) {
            this.showSnackbar('error', __('Nie je zvolená AI funkcia'));
            return;
        }

        // Zavrieme lightbox
        this.closeLightbox('multiai');

        // Zobrazime loading
        lightbox.multiai.callbackLoading();

        let requestParams = {};

        // Nasetujeme filter
        _.forEach(items.filtered, (value, key) => {
            requestParams = { ...requestParams, ...{ [`filter_${key}`]: value } };
        });

        const slug = lightbox.multiai.slug.replace('===', ',');

        await request(
            `/products-full/multiAi/${slug}/${lightbox.multiai.ids}`,
            { variable_inputs: _.keys(lightbox.multiai.variable_inputs), variables: lightbox.multiai.variables },
            'POST',
            requestParams
        ).then(response => {
            const { status, data } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa vytvoriť AI úlohu'));
                return;
            }

            if (data.multiple) {
                window.location = '/ai-commands';
            } else {
                window.location = `/ai-commands/view/${data.ai_command_id}`;
            }
        });

        // Zavolame callback
        lightbox.multiai.callback();
    }

    onDeleteMultiAiVariableInput(key) {
        const { lightbox } = this.state;

        if (_.keys(lightbox.multiai.variable_inputs).length === 1) {
            return;
        }

        const variable_inputs = _.omit(lightbox.multiai.variable_inputs, [key]);

        this.onChangeMultiAi('variable_inputs', variable_inputs);
    }

    onAddMultiAiVariableInput(key) {
        const { lightbox } = this.state;

        this.onChangeMultiAi('variable_inputs', { ...lightbox.multiai.variable_inputs, [key]: key });
    }

    onSetMultiAiVariableInput(key) {
        this.onChangeMultiAi('variable_inputs', { [key]: key });
    }

    onChangeMultiAiVariable(key, value) {
        const { lightbox } = this.state;

        this.onChangeMultiAi('variables', { ...lightbox.multiai.variables, [key]: value });
    }

    renderMultiAiLightbox() {
        const { items } = this.props;
        const { lightbox } = this.state;

        const functions = _.reduce(items.ai_functions, (result, name, slug) => {
            return { ...result, [slug]: _.has(AI_FUNCTION_NAMES, name) ? AI_FUNCTION_NAMES[name] : name };
        }, {});

        const { ai_functions_variables, ai_functions_with_variable_input } = items;

        let variableInputContent = null;
        let translateContent = null;

        const allowTranslate = lightbox.multiai.slug === AI_TRANSLATE_FUNCTION_SLUG
            && _.has(ai_functions_variables, AI_TRANSLATE_FUNCTION_SLUG)
            && !_.isEmpty(ai_functions_variables[AI_TRANSLATE_FUNCTION_SLUG]);
        const allowVariableInput = !allowTranslate && _.includes(ai_functions_with_variable_input, lightbox.multiai.slug);

        if (allowVariableInput) {
            const inputs = _.map(lightbox.multiai.variable_inputs, (key) => {
                return <Chip
                    onDelete={() => this.onDeleteMultiAiVariableInput(key)}
                    label={this.aiVariableInputs[key]}
                    key={key}
                />;
            });

            variableInputContent = (
                <div className="full-products-ai-function__variable-input">
                    <div className="full-products-ai-function__variable-input__label input__label">{__('Informácie o produkte pre AI')}</div>
                    <div className="full-products-ai-function__variable-input__inputs">
                        {inputs}
                    </div>
                    <Select
                        label={__('Pridať informáciu')}
                        options={_.omit(this.aiVariableInputs, _.keys(lightbox.multiai.variable_inputs))}
                        onChange={value => this.onAddMultiAiVariableInput(value)}
                    />
                </div>
            );
        } else if (allowTranslate) {
            translateContent = (
                <div className="full-products-ai-function__translate">
                    <Select
                        label={__('Údaj na preloženie')}
                        options={AI_TRANSLATE_PRODUCT_INPUTS}
                        value={!_.isEmpty(lightbox.multiai.variable_inputs) ? _.keys(lightbox.multiai.variable_inputs)[0] : null}
                        onChange={value => this.onSetMultiAiVariableInput(value)}
                        multiple
                    />
                    <Select
                        label={__('Jazyk')}
                        options={ai_functions_variables[AI_TRANSLATE_FUNCTION_SLUG].language.options}
                        value={lightbox.multiai.variables.language}
                        onChange={value => this.onChangeMultiAiVariable('language', value)}
                    />
                </div>
            );
        }

        return (
            <div className="full-products-ai-function">
                {lightbox.multiai.ids !== 'all' && lightbox.multiai.ids.indexOf(',') === -1 ? <Message type="warning" style={{ marginBottom: '20px' }}>{__('Dáta k jednotlivému produktu cez AI viete generovať aj detaile produktu.')}</Message> : null}
                <Select
                    label={__('AI funkcia')}
                    options={functions}
                    value={lightbox.multiai.slug}
                    onChange={value => this.onChangeMultiAi('slug', value)}
                />
                {variableInputContent}
                {translateContent}
            </div>
        );
    }

    renderScreen() {
        const { user } = this.props;
        const { lightbox } = this.state;

        return (
            <div>
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete zmazať tento produkt?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
                {this.renderLightbox(
                    'multidelete',
                    __('Naozaj chcete zmazať označené produkty?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.multiDelete()
                )}
                {this.renderLightbox(
                    'multiai',
                    __('AI úloha'),
                    !_.isEmpty(lightbox.multiai) ? this.renderMultiAiLightbox() : null,
                    __('Vytvoriť'),
                    __('Zrušiť'),
                    () => this.multiAi()
                )}
                {this.renderLightbox(
                    'importExcel',
                    __('Import Excel zo súboru'),
                    !_.isEmpty(lightbox.importExcel) ? (lightbox.importExcel.loading ? this.renderLoading(20) : <div>
                        <div className="prime_products__upload">
                            <UploadIcon />
                            <div className="prime_products__upload__text">{__('Nahrajte súbor vo formáte xlsx.')}</div>
                            <input type="file" onChange={event => this.uploadExcelFile(event.target.files[0])} />
                        </div>
                    </div>) : null,
                    '',
                    __('Zrušiť'),
                    () => {}
                )}
                {this.renderDrawer('product', {
                    title: __('Produkt'),
                    content: props => <Product
                        showSnackbar={(type, message) => this.showSnackbar(type, message)}
                        user={user}
                        {...props}
                    />,
                })}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ full_products, user }) => ({ items: full_products, user });

export default withCookies(connect(stateToProps, {
    fetch: fetchFullProducts,
    clean: cleanFullProducts,
    setUser,
    changeUserSetting,
    deleteFullProduct,
    deleteFullProducts,
})(FullProductsScreen));
